/**
 * @voltxampere/engine — Ground AC stamp (Sprint 20)
 *
 * Ground is structural. The DC ground stamp asserts that the wired
 * net is the canonical ground (index `-1`); the AC stamp does the
 * same. No matrix or RHS contribution.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { ContractViolationError } from "@voltxampere/shared";
import { getTerminalNetId } from "../terminal-utils.js";
export const groundACStamp = (ctx, component) => {
    const idx = ctx.nodeIndex(getTerminalNetId(component, "p"));
    if (idx !== -1) {
        throw new ContractViolationError(`groundACStamp: component "${component.id}" is wired to a non-ground net (planner should pin the ground net before stamping)`);
    }
};
//# sourceMappingURL=ground.js.map